var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcExitCidRovered(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.35938,
    cy: 8,
    r: 6,
    fill: "#545C62"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8313 5.54811C11.1437 5.86053 11.1437 6.36706 10.8313 6.67948L7.06007 10.4507C6.74765 10.7631 6.24112 10.7631 5.9287 10.4507C5.61628 10.1383 5.61628 9.63176 5.9287 9.31934L9.69994 5.54811C10.0124 5.23569 10.5189 5.23569 10.8313 5.54811Z",
    fill: "#F1F3F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8328 10.4505C10.5203 10.7629 10.0138 10.7629 9.70138 10.4505L5.93015 6.67921C5.61773 6.36679 5.61773 5.86026 5.93015 5.54784C6.24256 5.23542 6.7491 5.23542 7.06152 5.54784L10.8328 9.31908C11.1452 9.6315 11.1452 10.138 10.8328 10.4505Z",
    fill: "#F1F3F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExitCidRovered);
export default __webpack_public_path__ + "static/media/ic-exit-cid-rovered.798c11f9206a9d80c49dd1fb67fcd781.svg";
export { ForwardRef as ReactComponent };